import React, { useEffect, useState, useCallback } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import './UsersList.css';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import TopBar from "./TopBar";
import { Col, Container, Form, Row } from "react-bootstrap";
import useAuth from "../../hooks/useAuth";
import { useRef } from "react";


const ListSthansInArthikSakha = () => {

  const [SthansInArthikSakha, setSthansInArthikSakha] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const SthansInArthikSakhaPerPage = 15;
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const [pranthNames, setPranthNames] = useState({});
  const { auth } = useAuth();
  // const [selectedArthikSakhaId, setSelectedArthikSakhaId] = useState();
  const [selectedArthikSakhaId, setSelectedArthikSakhaId] = useState(auth?.level_id); // default value
  const nameRef = useRef();
  const [nameSearchTimeout, setNameSearchTimeout] = useState(null);
  const [name, setName] = useState("");

  useEffect(() => {
    if (auth?.level_id) {
      setSelectedArthikSakhaId(auth.level_id);
    }
  }, [auth]);


  const fetchSthansInArthikSakha = useCallback(async () => {
    setError(null); // clear previous error
    try {
      const response = await axiosPrivate.get(`list-sthans-in-arthik-sakha?arthik_sakha_id=${selectedArthikSakhaId}`, {
        withCredentials: true,
      });
      const franchiseList = response.data;
      setSthansInArthikSakha(franchiseList);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching Vibhags:", error);
      setError(error?.response?.data?.message?.toString() || error?.message || "No Vibhags available.");
      setLoading(false);
    }
  }, [axiosPrivate, selectedArthikSakhaId]); // 👈 dependency added




  const handleViewClick = (SthanId, SthanName) => {
    // Navigate to the GetFranchise component with franchiseId as a URL parameter
    navigate(`/sthan/users/${SthanId}/${SthanName}`);
  };
  const handleViewGurudakshina = (SthanId, SthanName) => {
    navigate(`/arthikShakha/list/GurudakshinaInSthan/${SthanId}/${SthanName}`);
  };



  useEffect(() => {
    fetchSthansInArthikSakha();
  }, [selectedArthikSakhaId]);




  const indexOfLastSthansInArthikSakha = currentPage * SthansInArthikSakhaPerPage;
  const indexOfFirstSthansInArthikSakha = indexOfLastSthansInArthikSakha - SthansInArthikSakhaPerPage;
  const currentSthansInArthikSakha = SthansInArthikSakha.slice(indexOfFirstSthansInArthikSakha, indexOfLastSthansInArthikSakha);

  const searchBySthanName = async (searchTerm) => {
    try {
      const response = await axiosPrivate.get(`/list-sthans-in-arthik-sakha?arthik_sakha_id=${selectedArthikSakhaId}&sthan=${searchTerm}`);

      setSthansInArthikSakha(response.data);
    } catch (err) {
      console.error("Search error", err);
      setError("Search failed. Please try again.");
    }
  };

  const handleNameChange = (e) => {
    const value = e.target.value.replace(/[^a-zA-Z\s]/g, '');
    setName(value);

    // Clear previous timeout
    if (nameSearchTimeout) {
      clearTimeout(nameSearchTimeout);
    }

    // Set new timeout for debounce
    const timeout = setTimeout(() => {
      if (value.length > 1) {
        searchBySthanName(value);
      } else {
        fetchSthansInArthikSakha(); // Load full list again
      }
    }, 500);

    setNameSearchTimeout(timeout);
  };
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const totalPages = Math.ceil(SthansInArthikSakha.length / SthansInArthikSakhaPerPage);

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  // if (error) {
  //   return <div className="error">{error}</div>;
  // }

  return (
    <>
      {/* <Container> */}
      <section className="empbody">
        <div className="wrapperemp2">

          <button onClick={() => navigate(-1)} className="btn btn-secondary newviewbtn"> ← Back</button>
          {/* <button onClick={handleRedirect} type="button" className="btn btn-success ms-auto d-block top-bt">+ Create Vibhag</button> */}
          <h3>Sthans In <span className="colorChange">{auth?.level_name}</span>  Arthiksakha</h3>

          <Row className="mb-3">
            <Col md={3}></Col>
            <Col md={6}>
              <div className="input-box arthik_input-box">
                <input
                  className="newinputstyles"
                  type="text"
                  id="name"
                  placeholder="Search by sthan name"
                  autoComplete="off"
                  ref={nameRef}
                  onChange={handleNameChange}
                  value={name}
                />
              </div>
            </Col>
            <Col md={3}></Col>
          </Row>

          <div className="table-container">
            <table id="customers">
              <thead>
                <tr>
                  <th>Sthan Id</th>
                  <th>Sthan Name</th>
                  <th>Sthan Name (MALAYALAM)</th>
                  <th>Mandal Name</th>
                  <th>Khand Name</th>
                  <th>users</th>
                  <th>SignedUp users</th>
                  <th>Options</th>
                </tr>
              </thead>

              <tbody>
                {error ? (
                  <tr>
                    <td colSpan="6" className="text-danger text-center">
                      {error}
                    </td>
                  </tr>
                ) : SthansInArthikSakha.length === 0 ? (
                  <tr>
                    <td colSpan="6">No Data available.</td>
                  </tr>
                ) : (
                  currentSthansInArthikSakha.map(SthansInArthikSakhas => (
                    <tr key={SthansInArthikSakhas.sthan_id}>
                      <td>{SthansInArthikSakhas.sthan_id}</td>
                      <td>{SthansInArthikSakhas.search_tag}</td>
                      <td>{SthansInArthikSakhas.sthan_name}</td>
                      <td>{SthansInArthikSakhas.mandal_name}</td>
                      <td>{SthansInArthikSakhas.khand_name}</td>
                      <td>{SthansInArthikSakhas.users}</td>
                      <td>{SthansInArthikSakhas.signed_up_users}</td>
                      <td>
                        <div className="d-flex justify-content-center">
                          <button type="button" className="btn btn-info btn-ico newicobtn newviewbtn" onClick={() => handleViewClick(SthansInArthikSakhas.sthan_id, SthansInArthikSakhas.search_tag)}>
                            All users
                          </button>
                          <button type="button" className="btn btn-info btn-ico newicobtn newviewbtn" onClick={() => handleViewGurudakshina(SthansInArthikSakhas.sthan_id, SthansInArthikSakhas.search_tag)}>
                            Gurudakshina
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>


            </table>
          </div>
          <div className="table-container">
            {totalPages > 1 && (
              <div className="pagination">
                <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>Previous</button>
                {Array.from({ length: totalPages }, (_, index) => (
                  <button
                    key={index}
                    onClick={() => handlePageChange(index + 1)}
                    disabled={currentPage === index + 1}
                  >
                    {index + 1}
                  </button>
                ))}
                <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>Next</button>
              </div>
            )}
          </div>
        </div>
      </section>
      <TopBar />
      {/* </Container> */}
    </>
  );
};

export default ListSthansInArthikSakha;
